/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Meta_TitleInputs */

const id_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi - egdata.app`)
};

const ms_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan - egdata.app`)
};

const da_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikationer - egdata.app`)
};

const de_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen - egdata.app`)
};

const en_us2_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications - egdata.app`)
};

const es_es2_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones - egdata.app`)
};

const es_mx2_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones - egdata.app`)
};

const fil_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Notipikasyon - egdata.app`)
};

const fr_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications - egdata.app`)
};

const it_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche - egdata.app`)
};

const hu_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értesítések - egdata.app`)
};

const nl_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen - egdata.app`)
};

const no_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varsler - egdata.app`)
};

const pl_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia - egdata.app`)
};

const pt_br2_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações - egdata.app`)
};

const pt_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações - egdata.app`)
};

const ro_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificări - egdata.app`)
};

const fi_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitukset - egdata.app`)
};

const sv_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiser - egdata.app`)
};

const vi_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo - egdata.app`)
};

const tr_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimler - egdata.app`)
};

const cs_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznámení - egdata.app`)
};

const bg_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Известия - egdata.app`)
};

const ru_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления — egdata.app`)
};

const uk_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення - egdata.app`)
};

const ar_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات - egdata.app`)
};

const hi_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएँ - egdata.app`)
};

const th_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือน - egdata.app`)
};

const ja_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知 - egdata.app`)
};

const zh_cn2_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知 - egdata.app`)
};

const zh_hant1_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知 - egdata.app`)
};

const ko_notifications_meta_title = /** @type {(inputs: Notifications_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림 - egdata.app`)
};

/**
* | output |
* | --- |
* | "Notifications - egdata.app" |
*
* @param {Notifications_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_meta_title = /** @type {((inputs?: Notifications_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_meta_title(inputs)
	if (locale === "ms") return ms_notifications_meta_title(inputs)
	if (locale === "da") return da_notifications_meta_title(inputs)
	if (locale === "de") return de_notifications_meta_title(inputs)
	if (locale === "en-US") return en_us2_notifications_meta_title(inputs)
	if (locale === "es-ES") return es_es2_notifications_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_notifications_meta_title(inputs)
	if (locale === "fil") return fil_notifications_meta_title(inputs)
	if (locale === "fr") return fr_notifications_meta_title(inputs)
	if (locale === "it") return it_notifications_meta_title(inputs)
	if (locale === "hu") return hu_notifications_meta_title(inputs)
	if (locale === "nl") return nl_notifications_meta_title(inputs)
	if (locale === "no") return no_notifications_meta_title(inputs)
	if (locale === "pl") return pl_notifications_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_meta_title(inputs)
	if (locale === "pt") return pt_notifications_meta_title(inputs)
	if (locale === "ro") return ro_notifications_meta_title(inputs)
	if (locale === "fi") return fi_notifications_meta_title(inputs)
	if (locale === "sv") return sv_notifications_meta_title(inputs)
	if (locale === "vi") return vi_notifications_meta_title(inputs)
	if (locale === "tr") return tr_notifications_meta_title(inputs)
	if (locale === "cs") return cs_notifications_meta_title(inputs)
	if (locale === "bg") return bg_notifications_meta_title(inputs)
	if (locale === "ru") return ru_notifications_meta_title(inputs)
	if (locale === "uk") return uk_notifications_meta_title(inputs)
	if (locale === "ar") return ar_notifications_meta_title(inputs)
	if (locale === "hi") return hi_notifications_meta_title(inputs)
	if (locale === "th") return th_notifications_meta_title(inputs)
	if (locale === "ja") return ja_notifications_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_meta_title(inputs)
	return ko_notifications_meta_title(inputs)
});
export { notifications_meta_title as "notifications.meta.title" }